import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import useScans from "../../store/scans/scansContext";
import ScanFiles from "./ScanFiles";
import FieldWithEdit from "../../components/FieldItems/FieldWithEdit";
import DicomStudyDownloader from './DicomStudyDownloader';
import { COLORS, SCAN_TYPES } from "../../config";
import DicomStudyData from "./DicomStudyData";
import SecondaryButtonAccent from "../../components/Buttons/SecondaryButtonAccent";
import DownloadIcon from "../../components/Icons/outline/DownloadIcon";
import EyeIcon from "../../components/Icons/solid/EyeIcon";
import { MoonLoader } from "react-spinners";

function ViewPatientScans({ scanId }) {
  const history = useHistory();
  const { getPatientScansDetails, viewDicomStudy, downloadDicomStudy } = useScans();
  const [isLoading, setIsLoading] = React.useState(true);
  const [patientScans, setPatientScans] = React.useState({});
  const [isDownloading, setIsDownloading] = React.useState(false)

  const [downloadStudy, setDownloadStudy] = React.useState(false);

  useEffect(() => {
    (async function fetchDetails() {
      await getPatientScansDetails(scanId)
        .then((res) => {
          const details = {
            id: res._id,
            description: res.description,
            type: res.type,
            name: res.user_id?.first_name + " " + res.user_id?.last_name,
          };
          setPatientScans(details);
          setIsLoading(false);
        })
        .catch((err) => {
          history.goBack();
        });
    })();
  }, [scanId]);

  const onDownloadClick = () => {
    setIsDownloading(true)
    downloadDicomStudy(scanId).then(res => {
      setIsDownloading(false)
      const blob = new Blob([res.data], { type: 'application/zip' });
      const url  = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${scanId}.zip`;      // filename shown in browser
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    })
  }


  return (
    <>
      <div className="bg-white rounded shadow py-12 px-10 mb-5">
        <div className="flex justify-between items-center w-full mb-10 relative">
          <h1 className="text-2xl text-secondary">Details</h1>
          {patientScans.type === SCAN_TYPES.CBCT_SCAN && <div className='flex gap-x-2'>
            <SecondaryButtonAccent onClick={() => onDownloadClick()} text={"Download study"} icon={<DownloadIcon stroke={COLORS.colorPrimary}/>} isLoading={isDownloading}/>
            <SecondaryButtonAccent onClick={() => viewDicomStudy(scanId)} text="View study" icon={<EyeIcon fill={COLORS.colorPrimary}/>} />
          </div>}
        </div>
        {isLoading ? 
          <div className=' flex justify-around min-h-170 pr-20 pl-20 items-center' >
            <MoonLoader color={COLORS.colorPrimary}/>
          </div> 
          : 
          <div className="grid grid-cols-1 gap-y-4">
            <FieldWithEdit label="Patient name" data={patientScans.name} />
            <FieldWithEdit label="Description" data={patientScans.description} />
            <FieldWithEdit label="Type" data={patientScans.type} />
            <FieldWithEdit
              label="Created"
              data={dayjs(patientScans.created_at).format("DD/MM/YYYY")}
            />
          </div>
        }
      </div>
      
      {
        patientScans.type !== SCAN_TYPES.CBCT_SCAN ?
        <ScanFiles scanType={patientScans.type} scanId={scanId} patientName={patientScans.name}/> :
        <DicomStudyData scanId={scanId}/>}
      {downloadStudy && <DicomStudyDownloader scanId={scanId} setDownloadStudy={setDownloadStudy}/>}
     
      
    </>
  );
}

export default ViewPatientScans;
